import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { SessionService } from '@core/services/session.service';
import { REWARDS_RAKEBACK_TIERS } from '@features/engagement/rewards/constants/rakeback.constants';
import { RewardsRakebackTier } from '@features/engagement/rewards/interfaces/rakeback.interface';

@Component({
  selector: 'app-rewards-rakeback-modal',
  imports: [],
  templateUrl: './rewards-rakeback-modal.component.html',
  styleUrl: './rewards-rakeback-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class RewardsRakebackModalComponent {
  sessionService = inject(SessionService);

  tiers = computed<RewardsRakebackTier[]>(() => {
    const profile = this.sessionService.profile();
    const userLevel = profile?.level;

    if (!userLevel) {
      return REWARDS_RAKEBACK_TIERS;
    }

    return REWARDS_RAKEBACK_TIERS.map((tier) => ({
      ...tier,
      isAvailable:
        userLevel >= tier.level.from &&
        userLevel < (tier.level.to ?? userLevel + 1),
    }));
  });
}
